import { render, staticRenderFns } from "./reviewedDetail.vue?vue&type=template&id=13ac5b36&scoped=true&"
import script from "./reviewedDetail.vue?vue&type=script&lang=ts&"
export * from "./reviewedDetail.vue?vue&type=script&lang=ts&"
import style0 from "./reviewedDetail.vue?vue&type=style&index=0&id=13ac5b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac5b36",
  null
  
)

export default component.exports